<template>
  <table class="nice-table-chart">
    <thead>
      <tr>
        <th v-for="(header, index) in props.headers" :key="index">{{ header }}</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, rowid) in data" :key="rowid" :style="{ color: row.color }">
        <td v-for="(col, colid) in row.cols" :key="colid">
          <div v-if="colid === 0" class="rank-wrapper" :style="{ backgroundImage: 'linear-gradient(' + row.bgColor + ',rgba(23, 45, 86, 0.5))', color: 'white' }">{{ col }}</div>
          <div v-else>{{ col }}</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
const props = defineProps({ headers: Array, data: Array })
</script>

<style lang="scss" scoped>
.nice-table-chart {
  width: fit-content;
  height: fit-content;
  background-color: rgba(0, 24, 72, 0.7);
  color: white;
  text-align: center;
  vertical-align: middle;
  border-collapse: collapse;
  line-height: 2em;
}
thead {
  border-top: 1px solid #0070ae;
  border-bottom: 1px solid #0070ae;
}
.rank-wrapper {
  display: inline-block;
  line-height: 1.5em;
  height: 1.5em;
  aspect-ratio: 1;
  text-align: center;
  vertical-align: middle;
  clip-path: circle(50%);
}
th,
td {
  padding: 0 5px;
}
</style>
